<template>
  <v-form v-model="valid" ref="mainForm">
    <opq-case code="fausse-declaration" v-model="sasEquivalence.fausseDeclaration" :live="liveSasEquivalence(3816)"></opq-case>
    <opq-case code="renseignements-exacts" v-model="sasEquivalence.delivrance" :live="liveSasEquivalence(3817)"></opq-case>
    <opq-case code="autorise-echange-informations" v-model="sasEquivalence.autoriseEchangeInformations" :live="liveSasEquivalence(3818)"></opq-case>
  </v-form>
</template>

<script>
import FormSimple from "@/mixins/FormSimple"
export default {
  mixins: [FormSimple],
  props: {
    sas: { type: Object }
  },
  methods: {
    liveSasEquivalence(cle) {
      return { endpoint: "sas-permis-psychologue-equivalence", cle: cle, fileId: this.sasEquivalence.id }
    }
  },

  computed: {
    sasEquivalence() {
      return this.sas.sasEquivalence
    }
  }
}
</script>

<style>
</style>